module.exports = "https://ec-cstatic.akulaku.net/mall/mobile/_next/static/images/bg_flash_sale-e9583024fbdfbecb90ce0407261a1803.png";